import { render, staticRenderFns } from "./EditModelModal.vue?vue&type=template&id=516c8ffe&scoped=true&"
import script from "./EditModelModal.vue?vue&type=script&lang=js&"
export * from "./EditModelModal.vue?vue&type=script&lang=js&"
import style0 from "./EditModelModal.vue?vue&type=style&index=0&id=516c8ffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516c8ffe",
  null
  
)

export default component.exports